import React from 'react';
import { messages } from '../constants/messages';
import { useContent } from '../ContentContext';

const About = () => {
  const { content } = useContent();
  const ab = (content as any).about || {};

  const badge      = ab.badge      || messages.about.badge;
  const titlePart1 = ab.titlePart1 || messages.about.titlePart1;
  const titlePart2 = ab.titlePart2 || messages.about.titlePart2;
  const p1         = ab.p1         || messages.about.p1;
  const p2         = ab.p2         || messages.about.p2;

  return (
    <section id="about" className="py-12 sm:py-24 px-4 sm:px-10 bg-white">
      <div className="container mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div className="order-2 lg:order-1">
          <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4 block">{badge}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-6 sm:mb-8 text-gray-900 leading-tight">
            {titlePart1} <span className="text-[#EF5D22]">{titlePart2}</span>
          </h2>
          <div className="space-y-4 text-gray-600 text-base sm:text-lg leading-relaxed">
            <div className="prose prose-sm max-w-none text-gray-600" dangerouslySetInnerHTML={{ __html: p1 }} />
            <div className="prose prose-sm max-w-none text-gray-600" dangerouslySetInnerHTML={{ __html: p2 }} />
            <div className="grid grid-cols-2 gap-4 sm:gap-8 pt-4 sm:pt-6">
              {messages.about.stats.map((stat, idx) => (
                <div key={idx} className="p-4 sm:p-6 bg-gray-50 rounded-2xl border border-gray-100">
                  <h4 className="text-2xl sm:text-4xl font-bold text-[#EF5D22] mb-1">{stat.value}</h4>
                  <p className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="order-1 lg:order-2 relative">
          <div className="rounded-2xl sm:rounded-[2rem] overflow-hidden shadow-2xl z-10 relative">
            <img
              src="/images/abhyasree.jpeg"
              alt="About Abhayasri"
              className="w-full h-full object-cover min-h-[300px] sm:min-h-[500px]"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 w-48 sm:w-64 h-48 sm:h-64 bg-[#EF5D22]/10 rounded-full -z-0 blur-3xl"></div>
          <div className="absolute -top-6 -left-6 w-32 sm:w-48 h-32 sm:h-48 bg-[#0066CC]/5 rounded-full -z-0 blur-2xl"></div>
        </div>
      </div>
    </section>
  );
};

export default About;
